module.exports = __webpack_public_path__ + "img/retrospect-30-mobile.7cf381d5.jpg";